import React from 'react';
import { ACTIVITY_TYPES_ICONS } from '../../Utils/constants/activityTypes';
import Dialog from '.';
import RecallForm from '../../Pages/CustomerPage/CallSection/ResultBox/RecallForm';

const RecallDialog = function RecallDialog({
  open,
  onClose,
  isOperator,
  phoneNumber,
  onSubmit,
}) {
  const Icon = ACTIVITY_TYPES_ICONS.CALL;

  const handleSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <Dialog
      id="recall-dialog"
      title="NEW_RECALL"
      icon={<Icon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      width="sm"
      fullWidth
      disableScroll
      form
      dividers
    >
      <RecallForm />
    </Dialog>
  );
};

export default RecallDialog;
